module.exports = __webpack_public_path__ + "static/media/65-iveco.3ccca70c.jpg";